module.exports = __webpack_public_path__ + "img/crm2_4.f25f51e4.png";